/* fc-pp-highlights.js (2026-10-12 speed pass): the highlights track (autoplay, arrows, dots, scroll sync).
   Moved out of sections/fc-pp-highlights.liquid so browsers cache it across product
   pages; the root is #fc-pp-hl and per-instance values travel as data
   attributes (or the JSON config script). The bodies are the former inline
   scripts, unchanged apart from those lookups. Re-initialises on
   shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initHighlights(root) {

  var track = root.querySelector('[data-fc-hl-track]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fc-hl-card]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fc-hl-dot]'));
  var nextBtn = root.querySelector('[data-fc-hl-next]');
  if (!track || cards.length < 2) return;

  var AUTOPLAY_MS = parseInt(root.getAttribute('data-fc-autoplay-ms'), 10) || 2000;
  var current = 0;
  var timer = null;
  var isPaused = false;
  var inView = true;
  var userScrolling = false;
  var scrollIdleTimer = null;

  function scrollLeftFor(idx) {
    // Center the target card within the track's viewport.
    var card = cards[idx];
    var trackRect = track.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var delta = (cardRect.left - trackRect.left) - (trackRect.width - cardRect.width) / 2;
    return track.scrollLeft + delta;
  }

  function goTo(idx, smooth) {
    current = ((idx % cards.length) + cards.length) % cards.length;
    track.scrollTo({ left: scrollLeftFor(current), behavior: smooth === false ? 'auto' : 'smooth' });
    updateActive();
  }

  function updateActive() {
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === current); });
    cards.forEach(function(c, i) { c.classList.toggle('is-active', i === current); });
  }

  function tick() {
    if (isPaused || !inView || userScrolling) return;
    goTo(current + 1);
  }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(tick, AUTOPLAY_MS);
  }
  function stopAutoplay() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      goTo(current + 1);
      // Brief autoplay reset so the next tick is a full interval away
      startAutoplay();
    });
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var idx = parseInt(dot.getAttribute('data-fc-hl-dot'), 10) || 0;
      goTo(idx);
      startAutoplay();
    });
  });

  // Click an adjacent (dimmed) card to focus it.
  cards.forEach(function(card) {
    card.addEventListener('click', function() {
      var idx = parseInt(card.getAttribute('data-fc-hl-card'), 10) || 0;
      if (idx === current) return;
      goTo(idx);
      startAutoplay();
    });
  });

  // Pause on hover / focus / touch
  root.addEventListener('mouseenter', function() { isPaused = true; });
  root.addEventListener('mouseleave', function() { isPaused = false; });
  root.addEventListener('focusin', function() { isPaused = true; });
  root.addEventListener('focusout', function() { isPaused = false; });
  track.addEventListener('touchstart', function() { isPaused = true; }, { passive: true });
  track.addEventListener('touchend', function() {
    // Resume shortly after touch ends so the user's swipe doesn't immediately advance
    setTimeout(function() { isPaused = false; }, 1200);
  }, { passive: true });

  // Keep `current` synced with user-driven scrolling (swipe / drag).
  track.addEventListener('scroll', function() {
    userScrolling = true;
    clearTimeout(scrollIdleTimer);
    scrollIdleTimer = setTimeout(function() {
      userScrolling = false;
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function(card, i) {
        var r = card.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - trackCenter);
        if (d < closestDist) { closestDist = d; closest = i; }
      });
      if (closest !== current) {
        current = closest;
        updateActive();
      }
    }, 120);
  }, { passive: true });

  // Pause autoplay when the section is not in view — saves work and lines up
  // the next slide with the first scroll-in.
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        inView = entry.isIntersecting;
      });
    }, { threshold: 0.15 });
    observer.observe(root);
  }

  startAutoplay();
  }
  function init() {
    var root = document.getElementById('fc-pp-hl');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initHighlights(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-pp-hl')) init();
  });
})();
